import { render, staticRenderFns } from "./MarksView.vue?vue&type=template&id=1671815a&scoped=true"
import script from "./MarksView.vue?vue&type=script&lang=js"
export * from "./MarksView.vue?vue&type=script&lang=js"
import style0 from "./MarksView.vue?vue&type=style&index=0&id=1671815a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671815a",
  null
  
)

export default component.exports